// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"7f24ae79","787":"61fb0770"}[chunkId] + ".chunk.js";
};